import { createClient } from "contentful";

const spaceId = "xt1olvl1q2wf";
const accessToken = "Z9q6U6uit04nE9shQq4GKoU5jQhHmUj_7Q_UQjC7fGs";

const client = createClient({
  space: spaceId,
  accessToken: accessToken,
});

const getAuthors = () =>
  client
    .getEntries({ content_type: "componentAuthor" })
    .then((response) => response.items);

const getTags = () =>
  client.getTags().then((tags) => tags.items.map((tag) => tag.name));

const getLandingPage = () =>
  client
    .getEntries({ content_type: "pageLanding" })
    .then((response) => response.items);

const getBlogPosts = (category) =>
  client
    .getEntries({
      content_type: "pageBlogPost",
    })
    .then((response) => {
      if (!category) {
        return response.items;
      }
      return response.items.filter(
        (item) =>
          item.fields.category &&
          item.fields.category.some(
            (cat) => cat.fields.categoryName === category
          )
      );
    });

const getSinglePost = (slug) =>
  client
    .getEntries({
      "fields.slug": slug,
      content_type: "pageBlogPost",
    })
    .then((response) => response.items);

const getGallery = () => client.getEntries({ content_type: "galleryImage" });

const getSidebarContent = () => client.getEntries({ content_type: "sidebar" });

export {
  getBlogPosts,
  getSinglePost,
  getGallery,
  getLandingPage,
  getTags,
  getAuthors,
  getSidebarContent,
};
